// app/middleware/notFoundSpain.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "espana") {
    throw createError({ statusCode: 404 });
  }
});
